import React from "react";
import MyDeskCard from "components/dashboard/MyDeskCard/MyDeskCard";
import NoticeCard from "components/dashboard/NoticeCard";
import ArchivesCard from "components/dashboard/ArchivesCard";
import styled, { css } from "styled-components";

const Home = () => {
  return (
    <ContentLayoutStyle>
      <MyDeskCard style={{ flex: 1 }} />
      <SideCardsStyle>
        <NoticeCard />
        <ArchivesCardOffset>
          <ArchivesCard />
        </ArchivesCardOffset>
      </SideCardsStyle>
    </ContentLayoutStyle>
  );
};

export default Home;

/* Styles */
export const ContentLayoutStyle = styled.div`
  width: 100%;
  margin-top: 2rem;

  display: flex;
  gap: 2rem;

  ${({ theme }) => css`
    ${theme.media.small} {
      flex-direction: column;
      gap: 1rem;
    }
  `}
`;

export const SideCardsStyle = styled.div`
  ${({ theme }) => css`
    ${theme.media.notSmall} {
      max-width: 49.3rem;
    }
  `}

  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const ArchivesCardOffset = styled.div`
  ${({ theme }) => css`
    ${theme.media.notSmall} {
      margin-top: auto;
    }
  `}
`;
